import React, { FunctionComponent, useEffect } from 'react';
import Modal from '@/components/shared/modal';
import Headline from 'headline-proxy';
import * as s from './styles.module.scss';
import Paragraph from '@/components/shared/paragraph';
import Button from 'button-proxy';

export const UKPopupForm: FunctionComponent = () => {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    window.addEventListener('keydown', handleEscape, true);
    return () => {
      window.removeEventListener('keydown', handleEscape, true);
    };
  }, []);

  const closeModal = () => {};

  return (
    <Modal className={s.modal} closeModal={closeModal} id="modal" nolineSearch noCancel>
      <div className={s.root}>
        <div className={s.iconWrapper}>
          <img className={s.logo} src="/svg/group-3155.svg" alt="Elite Body Sculpture Logo" />
        </div>
        <Headline h2 className={s.headline} html="The Elite Body Sculpture office in London has closed." />
        <Paragraph
          className={s.bodyText}
          html="Please visit our US site to select from over 30 premier locations offering body contouring."
        />
        <div className={s.ctaButtonWrapper}>
          <Button
            id="uk-popup-button"
            className={s.ctaButton}
            link={{
              external: true,
              externalHref: 'https://airsculpt.com/',
              id: 'uk-popup-visit-us-site',
            }}
          >
            VISIT U.S. SITE
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default UKPopupForm;
